import React from 'react'
import { AppStatus } from '@/redux'
import { onUpdate } from '@codeleap/common'
import { APIClient } from '@/services'
import Landing from './home/landing'

export default Landing
